export default __webpack_public_path__ + "static/media/shop9.929e4627.jpg";